import { useSetPrototypeAppsOptInMutation } from '../../services';
import { useGetUserId } from '../useCredentials';
import { useUpsertTenantSettingsMutation } from '../../services/tenant/operations.enhanced';

export const usePrototypeAppsOptIn = () => {
  const userId = useGetUserId();
  const [
    setPrototypeAppsOptInMutation,
    { isLoading: ogLoading, error: ogError },
  ] = useSetPrototypeAppsOptInMutation();
  const [
    upsertTenantSettingsMutation,
    { isLoading: coreLoading, error: coreError },
  ] = useUpsertTenantSettingsMutation();

  const setPrototypeAppsOptIn = async () => {
    // Update in mysql
    await setPrototypeAppsOptInMutation({ userId }).unwrap();
    // Update in postgres tenant settings
    await upsertTenantSettingsMutation({
      input: { hasOptedInToPrototypeApps: true },
    }).unwrap();
  };

  return {
    setPrototypeAppsOptIn,
    isLoading: ogLoading || coreLoading,
    error: ogError || coreError,
  };
};
